import React, {Component} from "react";
import {CONTROL_PANEL_ROUTE} from "../../../utils/constants/RoutesConstants";
import {ControlPanelService} from "../../../service/controlPanel/ControlPanelService";
import ReturnMaturity from "./ReturnMaturityView";
import {Growl} from "primereact/growl";

export default class ReturnMaturityContainer extends Component {
    constructor(props) {
        super(props);

        this.controlPanelService = new ControlPanelService();

        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.returnLoanMaturity = this.returnLoanMaturity.bind(this);
        this.saveDataReturnMaturity = this.saveDataReturnMaturity.bind(this);

        this.state = {
            isLoading: true,
            loanId: this.props.location.state.folio,
            selectedLoan: this.props.location.state.selectedLoanControlPanel,
            returnDays: 0,
        }
    };

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleReturnButton(message) {
        this.props.history.push({
            pathname: CONTROL_PANEL_ROUTE,
            message:message,
        });
    }

    returnLoanMaturity() {
        this.loading(true);
        this.controlPanelService.returnLoanMaturity(
            this.state.loanId,
            this.state.returnDays,)
            .then(resp => {
                if (resp.error !== '') {
                    this.growl.show({severity: 'error', summary: 'Error.', detail: resp.error});
                } else {
                    let message = {
                        severity: 'success',
                        summary: 'Éxito',
                        detail: 'Se ha actualizado su solicitud correctamente.',
                    };
                    this.handleReturnButton(message);
                }
                this.loading(false);
            });
    }

    saveDataReturnMaturity(event) {
        const {name, value} = event.target;

        this.setState({[name]: value,});
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        return <ReturnMaturity
            isLoading={this.state.isLoading}
            loading={this.loading}
            handleReturnButton={this.handleReturnButton}
            saveDataReturnMaturity={this.saveDataReturnMaturity}
            loanId={this.state.loanId}
            selectedLoan={this.state.selectedLoan}
            returnLoanMaturity={this.returnLoanMaturity}
            messagesGrowl={messagesGrowl}
        />

    }
};